import React from "react";
import { Link, useLocation } from "react-router-dom";

const SupplierTabBar = ({ supplierId }) => {
  const location = useLocation();

  const tabs = [
    {
      id: "general",
      label: "General",
      link: `/supplier/updateSupplier/${supplierId}`,
      icon: "fa fa-info-circle"
    },
    {
      id: "products",
      label: "Products",
      link: `/supplier/updateSupplierProducts/${supplierId}`,
      icon: "fa fa-box"
    },
  ];

  const getActiveTab = () => {
    if (location.pathname.includes("updateSupplierProducts")) {
      return "products";
    }
    return "general";
  };

  const activeTab = getActiveTab();

  return (
    <ul className="nav nav-tabs nav-tabs-v2 px-3 mb-3">
      {tabs.map((tab) => (
        <li className="nav-item me-2" key={tab.id}>
          <Link
            to={tab.link}
            className={`nav-link px-2 ${activeTab === tab.id ? "active" : ""}`}
          >
            <i className={`${tab.icon} me-2`}></i>
            {tab.label}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default SupplierTabBar;